export const USER_LOGIN_SERVICE_BASE_URL = 'https://api.fundamentally.eu/users';
//export const USER_LOGIN_SERVICE_BASE_URL = 'http://localhost:8081';
export const TEMPLATE_SERVICE_BASE_URL = 'https://api.fundamentally.eu/templates';
//export const TEMPLATE_SERVICE_BASE_URL = 'http://localhost:5100';
export const SUBSCRIPTION_SERVICE_BASE_URL = 'https://api.fundamentally.eu/subscription-service';
export const USER_DOCUMENTS_SERVICE_BASE_URL = 'https://api.fundamentally.eu/templates/users';
//export const USER_DOCUMENTS_SERVICE_BASE_URL = 'http://localhost:5100/users';
export const ORGANIZATION_ID = "documentally";